import { defineComponent as _defineComponent } from 'vue'
import {desanitizeString} from "@/utils/Helpers";
import VNutritionLabel from "@/components/vNutritionLabel.vue";
import {PrintRecipeDetails} from "@/models/Recipes/PrintRecipeDetails";
import {DishRecipeCommon} from "@/models/DishRecipeCommon";
import { DailyValueCalculationMethod } from "@/models/Recipes/DailyValueCalculationMethod";
import {RecipeCompositionMeasurement} from "@/models/Recipes/RecipeCompositionMeasurement";
import {RecipeIngredient} from "@/models/Recipes/RecipeIngredient";


export default /*#__PURE__*/_defineComponent({
  __name: 'vRecipePrintout',
  props: {
    recipe: null,
    selectedCountry: null,
    printMeta: null,
    dailyValueCalculationMethod: null,
    servingsPerContainer: null,
    subrecipeServingSizes: null,
    ingredients: { default: () => [] },
    containsAllergensText: { default: "" },
    roundingIndex: { default: 0 },
    isSupplementLabel: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { recipe: DishRecipeCommon, selectedCountry: string, printMeta: PrintRecipeDetails, dailyValueCalculationMethod: DailyValueCalculationMethod, servingsPerContainer : number, subrecipeServingSizes: RecipeCompositionMeasurement[], ingredients: RecipeIngredient[], containsAllergensText: string, roundingIndex: number, isSupplementLabel: boolean };



function getSubrecipeMeasurementByCompositionMeasurementId(compositionMeasurementId: number) {
  return props.subrecipeServingSizes.find(
    (rcm: RecipeCompositionMeasurement) => rcm.id === compositionMeasurementId
  )!.measurement;
}

return { __sfc: true,props, getSubrecipeMeasurementByCompositionMeasurementId, desanitizeString, VNutritionLabel, DailyValueCalculationMethod }
}

})